// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1nMhD","title":"Images90_title__3hpuY","images":"Images90_images__2rd-n"};